import React from 'react'
import PolygonCreator3000 from './components/PolygonCreator3000/PolygonCreator3000'
import styles from './InlineTool.module.css'

export const InlineTool = () => {
    return (
        <div className={styles.root}>
            <PolygonCreator3000 />
        </div>
    )
}
